/**
 *
 * PopoverLinklist
 *
 */

import React from 'react';

import Popover from './'
import Icon from 'components/Icon'
import { Link } from 'react-router-dom'
import {
  LinkedlistItems,
  LinkedlistItem,
} from './styledComponents';

class PopoverLinklist extends React.PureComponent {


  render() {

    /*
        links = [title, href, style, onClick]
    */
    const { links } = this.props

    return (
      <Popover>
        <Icon
          name='menu'
          padding="14px 9px"
        />
        <LinkedlistItems>
          {links.map((link, i) =>
              <Link key={i} to={link.href ? link.href : ''} onClick={(e) =>  {
                    if(link.onClick) {
                      e.preventDefault();
                      link.onClick();
                    }
                  }}>
                <LinkedlistItem className={link.style ? link.style : null}>
                    <div>{link.title}</div>
                </LinkedlistItem>
              </Link>
          )}
        </LinkedlistItems>
      </Popover>
    );
  }
}

export default PopoverLinklist;



// WEBPACK FOOTER //
// ./src/components/Popover/PopoverLinklist.js